import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedCustomTextsView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/custom_text/applied_custom_texts"]

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

  render: ->
    @$el.html(@template())
    _.each @searchQuery.get('custom_texts'), (values, key) =>
      @$el.append new GenericAppliedTextFilterView($.extend({ name: key, values: values}, @options)).render().el
    return this

  destroy: ->
    this.remove()
    return false

class GenericAppliedTextFilterView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView

  initialize: (@options = {}) ->
    super
    @name = @options.name
    @alias = _.str.humanize(@name)
    @values = @options.values

  getAppliedValues: ->
    @values

  removeFilter: (value) ->
    @searchQuery.removeCustomText(@name, value)

  clear: (event) =>
    @searchQuery.get('custom_texts')[@name] = []
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)